module.exports = __webpack_public_path__ + "img/med-sync-logo.8fc0ca2e.png";